import querystring from "querystring";
import createHash from "sha.js";

import ajax from "@/libs/Ajax";

// 密码加密统一算法
function encodePasswd(pwd) {
  let sha256 = createHash("sha256");
  // return md5(sha256.update(pwd).digest("hex"));
  let r = sha256.update(pwd).digest("hex");
  return r;
}

export default {
  /**
   * 用户登录
   * @param userid 用户ID
   * @param passwd 密码
   * @param captcha 验证码
   * @return {Promise}
   */
  login({userid, passwd}) {
    passwd = encodePasswd(passwd);
    return ajax.request({
      message: true,
      method: "post",
      url: "/ClientController/login",
      data: querystring.stringify({userid, passwd}),
      headers: {"Content-type": "application/x-www-form-urlencoded"}
    });
  },
  pgswitch(params) {
    return ajax.get("/page/switch", {
      params: params
    });
  },
};
